import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectPage } from './pages/ProjectPage';
import { VerifyPage } from './pages/VerifyPage';
import { ButtonGalleryPage } from './pages/ButtonGalleryPage';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
        <p>Loading HistoRyjki...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/auth/verify" element={<VerifyPage />} />
      {import.meta.env.DEV && (
        <Route path="/design/buttons" element={<ButtonGalleryPage />} />
      )}
      <Route
        path="/"
        element={user ? <DashboardPage /> : <Navigate to="/login" />}
      />
      <Route
        path="/project/:projectId/*"
        element={user ? <ProjectPage /> : <Navigate to="/login" />}
      />
    </Routes>
  );
}
